<div class="filter-group" data-group-visibility-id="showFavouriteCurrencyFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showFavouriteCurrencyFilters" (click)="filter.groupVisibility.showFavouriteCurrencyFilters = !filter.groupVisibility.showFavouriteCurrencyFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Favourite Currency" [activeRules]="activeRules.favouriteCurrencyFilters + activeSpecialRules.favouriteCurrencyTypes">
          You might consider certain currency more valuable than their market price would suggest. Reasons might include:
          <br />- You use the currency yourself regularly for crafting
          <br />- It's more liquid on the market
          <br />- You're running that type of content and sell everything in bulk
          @if (poe1) {
            <br />- You can upgrade it in bulk
          }
          <br /><br />Here you can boost the tier of these types of currency, through a value multiplier, tier promotion, or by just forcing them to be at least visible.
          <br /><br />Rules which have a <span class="equipment-filter-from-preset-example">gold line</span> in front were automatically generated from your Endgame Content Preset.
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showFavouriteCurrencyFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showFavouriteCurrencyFilters">

      <app-favourite-basic-currency-filter
        [enabled]="filter.favouriteBasicCurrency"
        [baseTypeOptions]="basicCurrencyOptions"
        [baseTypes]="filter.favouriteBasicCurrencyTypes"
        [mode]="filter.favouriteBasicCurrencyMode"
        [value]="filter.favouriteBasicCurrencyValue"
        (enabledToggled)="toggleFavouriteBasicCurrency()"
        (baseTypesChange)="filter.favouriteBasicCurrencyTypes = $event; rebuildCurrencyTiers()"
        (modeChange)="onBasicModeChanged($event)"
        (valueChange)="filter.favouriteBasicCurrencyValue = $event; rebuildCurrencyTiers()">
      </app-favourite-basic-currency-filter>

      @if (poe1) {
        <app-favourite-basic-currency-filter
          [enabled]="filter.favouriteScarabs"
          [label]="'Scarabs'"
          [baseTypeOptions]="scarabContentOptions"
          [baseTypes]="filter.favouriteScarabsTypes"
          [mode]="filter.favouriteScarabsMode"
          [value]="filter.favouriteScarabsValue"
          (enabledToggled)="toggleFavouriteScarabs()"
          (baseTypesChange)="onScarabsTypesChange($event)"
          (modeChange)="onScarabsModeChanged($event)"
          (valueChange)="filter.favouriteScarabsValue = $event; rebuildCurrencyTiers()">
        </app-favourite-basic-currency-filter>
      }

      @for (entry of filter.favouriteCurrencyTypes; track $index) {
        <app-favourite-currency-type-filter
          [entry]="entry"
          [index]="$index"
          [itemTypeOptions]="rowItemTypeOptions[$index]"
          (remove)="removeFavouriteCurrencyType($event)"
          (changed)="onRowChanged()">
        </app-favourite-currency-type-filter>
      }

      <div class="filter filter-padded">
        <button type="button" class="btn clear-btn" style="width: 100%;" (click)="addFavouriteCurrencyType()">
          Add new Favourite Currency Type
        </button>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>
